import React, { Component } from 'react';
import './index.css';
import { useNavigate } from "react-router-dom";
import { useAuth } from 'fennec-ui';
// or 'antd/dist/antd.less'
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';


//https://www.youtube.com/watch?v=hjp-JHVsgxQ
//https://github.com/pantharshit00/jwt-react-auth
//https://hptechblogs.com/using-json-web-token-react/
//https://github.com/pantharshit00/jwtAuth

function String({ value, onChange, prefix, placeholder }) {
  return (
    <Input allowClear value={value} prefix={prefix} placeholder={placeholder} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function Login(props) {
  let navigate = useNavigate();
  const auth = useAuth();

  const handleSubmit = (values) => {
    auth.login(values.username, values.password).then(res => {
      if (!res.status) {
        message.error(res.message);
      }
    })
  };

  var nurl = new URL(window.location.href);
  var refUrl = nurl.searchParams.get("service");

  // //Чистим куки token при открытии формы логин. Возможны грабли.
  // window.document.cookie = 'token=; Max-Age=0; path=/; domain=' + auth.getDomainWithoutSubdomain(window.location.href);
  return (
    <div className="login-form">
      <div style={{ textAlign: "center" }}>
        <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
          <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
        </a>
      </div>

      <Form name="normal_login" onFinish={handleSubmit} className="login-form">
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Пожалуйста, введите адрес электронной почты!' }]}
        >
          <String
            prefix={<UserOutlined />}
            placeholder="Адрес электронной почты"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Пожалуйста, введите пароль!' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            // type="password"
            placeholder="Пароль"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Войти
          </Button>
        </Form.Item>
        {/* <a href={(refUrl) ? "/signup?service=" + refUrl : "/signup"}>зарегистрироваться!</a> */}
        {/* <a href="/forgot-password">Забыли пароль?</a> */}
      </Form>
      <div>
        <div style={{padding:"15px 0"}}>
          <div className='line'><span>или</span></div>
        </div>
        <Button style={{ width: "100%" }} href={(refUrl) ? "/signup?service=" + refUrl : "/signup"} type="default">
          Зарегистрироваться!
        </Button>
        <div style={{padding:"15px 0"}}>
        <Button style={{ width: "100%" }} href='/forgot-password' type="ghost">
          Забыли пароль?
        </Button>
        </div>
      </div>
    </div>
  );
}

// const Login = Form.create({ name: 'normal_login' })(NormalLoginForm);
export default Login;